import { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import {
    buildFieldValidationMessages,
    FieldValidationOptions,
    FieldValidationRules,
    validateFieldValue,
} from "../../../Util/fieldValidation";

export const useDashlyFieldValidation = (
    value: unknown,
    validation?: FieldValidationRules,
    options?: FieldValidationOptions,
) => {
    const { t } = useTranslation();
    const [touched, setTouched] = useState(false);

    const messages = useMemo(
        () => buildFieldValidationMessages(t, validation),
        [t, validation],
    );

    const result = useMemo(
        () => validateFieldValue(value, validation, messages, options),
        [value, validation, messages, options],
    );

    const markTouched = useCallback(() => setTouched(true), []);

    const showError = Boolean(validation && touched && !result.valid);

    return {
        error: showError ? result.message : undefined,
        invalid: showError,
        isValid: result.valid,
        markTouched,
        resolvedMaxLength: validation?.maxLength,
    };
};
